let initialized = false;

export function initSmoothScroll() {
  if (initialized) return;
  initialized = true;

  const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
  const pointerQuery = window.matchMedia("(any-pointer: fine)");
  let lenis = null;
  let frame = null;
  let previousTime = null;
  let animationTime = 0;

  function tick(time) {
    frame = null;
    if (!lenis || document.hidden) return;
    // Lenis uses elapsed time internally. Exclude idle time so the next wheel
    // gesture does not jump straight to its destination after a long pause.
    animationTime += previousTime === null ? 16 : Math.min(time - previousTime, 32);
    previousTime = time;
    lenis.raf(animationTime);
    if (lenis.isScrolling === "smooth") {
      frame = requestAnimationFrame(tick);
    } else {
      previousTime = null;
    }
  }

  function wake() {
    if (frame === null && lenis && !document.hidden) frame = requestAnimationFrame(tick);
  }

  function updateMode() {
    const enabled = pointerQuery.matches && !motionQuery.matches && !document.hidden;
    if (enabled && !lenis && typeof window.Lenis === "function") {
      lenis = new window.Lenis({ smoothWheel: true, syncTouch: false });
      lenis.on("virtual-scroll", wake);
    } else if (!enabled && lenis) {
      if (frame !== null) cancelAnimationFrame(frame);
      frame = null;
      previousTime = null;
      lenis.destroy();
      lenis = null;
    }
  }

  motionQuery.addEventListener("change", updateMode);
  pointerQuery.addEventListener("change", updateMode);
  document.addEventListener("visibilitychange", updateMode);
  updateMode();

  document.addEventListener("click", (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const anchorLink = event.target.closest("a[href]");
    if (!anchorLink || anchorLink.hasAttribute("download") || (anchorLink.target && anchorLink.target !== "_self")) return;

    let url;
    let target;
    try {
      url = new URL(anchorLink.href, window.location.href);
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || url.search !== window.location.search || !url.hash) return;
      target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    } catch {
      return;
    }

    if (!target) return;

    event.preventDefault();

    const header = document.querySelector(".header");
    const headerOffset = (header?.offsetHeight || 0) + 16;
    if (lenis) {
      lenis.scrollTo(target, { offset: -headerOffset, duration: 0.9 });
      wake();
    } else {
      window.scrollTo({
        top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - headerOffset),
        behavior: motionQuery.matches ? "instant" : "smooth",
      });
    }

    window.history.replaceState(window.history.state, "", url.hash);
  });

}
